'use strict';

import { AdvanceFeasibilityCriteria } from '../interfaces/feasibility.interface';

export const FILTER_TYPE = {
  INPUT: 'input-dropdown',
  SELECT_DROPDOWN: 'select-dropdown',
  TREE_DROPDOWN: 'tree-dropdown',
};

export const CRITERIAS = {
  PROJECT_MANAGER: {
    id: 1,
    name: 'Project Manager',
  },
  BILLING_NUMBER: {
    id: 2,
    name: 'Billing Number',
  },
  TEMPLATE: {
    id: 3,
    name: 'Template',
  },
};

export const ADVANCE_FEASIBILITY_CRITERIAS: AdvanceFeasibilityCriteria[] = [
  {
    name: CRITERIAS.PROJECT_MANAGER.name,
    id: CRITERIAS.PROJECT_MANAGER.id,
    filterType: FILTER_TYPE.SELECT_DROPDOWN,
  },
  {
    name: CRITERIAS.BILLING_NUMBER.name,
    id: CRITERIAS.BILLING_NUMBER.id,
    filterType: FILTER_TYPE.INPUT,
  },
  {
    name: CRITERIAS.TEMPLATE.name,
    id: CRITERIAS.TEMPLATE.id,
    filterType: FILTER_TYPE.TREE_DROPDOWN,
  },
];
